import React from "react";
import { Button, Grid, Paper } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";


export const ButtonSubmit = (props) => {
    return (
        <>
            <Grid container spacing={2} sx={{ pt: 3 }}>
                <Grid item xs={12}>
                    <Paper elevation={2} >
                        <Button
                            type="submit"
                            fullWidth
                            endIcon={<SendIcon />}
                            variant={ props.variant }
                        >
                            { props.label }
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </>
        
    );
};
